import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  ErrorHandler,
  provideZoneChangeDetection,
} from '@angular/core';
import { MAT_DATE_FNS_FORMATS } from '@angular/material-date-fns-adapter';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideRouter,
  withInMemoryScrolling,
  withRouterConfig,
} from '@angular/router';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { isMobileDevice } from '@Login/pages/login-view/login.guard';
import { ErrorDialogService } from '@UIparts/common/error-dialog/mobile-ver/error-dialog.service';
import { PcTabletErrorDialogService } from '@UIparts/common/error-dialog/pc-tablet-ver/error-dialog.service';
import { LoadingSpinnerService } from '@UIparts/common/loading-spinner/mobile-ver/loading-spinner.service';
import { PcTabletLoadingSpinnerService } from '@UIparts/common/loading-spinner/pc-tablet-ver/loading-spinner.service';
import { VineyardDateFnsAdapter } from '@VineyardLib/adapters/vineyard-date-fns.adapter';
import { VineyardErrorHandler } from '@VineyardLib/error-handler/vineyard-error-handler';
import { httpErrorInterceptor } from '@VineyardLib/interceptors/http-error/http-error.interceptor';
import { httpLoadingInterceptor } from '@VineyardLib/interceptors/http-loading/http-loading.interceptor';
import {
  httpRequestInterceptor,
  PACKAGE_INFO_TOKEN,
} from '@VineyardLib/interceptors/http-request/http-request.interceptor';
import { ERROR_DIALOG_SERVICE_TOKEN } from '@VineyardLib/services/error-dialog-wrapper.service';
import { LOADING_SPINNER_SERVICE_TOKEN } from '@VineyardLib/services/loading-spinner-wrapper.service';
import { VineyardWebApi } from '@WebAPI';
import { routes } from './app.routes';
// Version
import packageInfo from '@Work/package.json';
const { version } = packageInfo;

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withRouterConfig({
        canceledNavigationResolution: 'computed',
        paramsInheritanceStrategy: 'always',
      }),
      withInMemoryScrolling({ scrollPositionRestoration: 'disabled' })
    ),
    // API
    VineyardWebApi,
    // Translation
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: './assets/translate/',
        suffix: '.json?version=' + version,
      }),
    }),
    // ErrorHandler
    {
      provide: ErrorHandler,
      useClass: VineyardErrorHandler,
    },
    // LoadingSpinner
    {
      provide: LOADING_SPINNER_SERVICE_TOKEN,
      useClass: isMobileDevice()
        ? LoadingSpinnerService
        : PcTabletLoadingSpinnerService,
    },
    // ErrorDialog
    {
      provide: ERROR_DIALOG_SERVICE_TOKEN,
      useClass: isMobileDevice()
        ? ErrorDialogService
        : PcTabletErrorDialogService,
    },
    // DateAdapter（MatDatePicker言語対応用）
    { provide: DateAdapter, useClass: VineyardDateFnsAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MAT_DATE_FNS_FORMATS },
    // MatFormFieldの共通見た目設定
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline', subscriptSizing: 'dynamic' },
    },
    // Version（interceptorでのバージョンチェック用）
    { provide: PACKAGE_INFO_TOKEN, useValue: packageInfo },
    // Interceptors
    provideHttpClient(
      withInterceptors([
        httpErrorInterceptor,
        httpRequestInterceptor,
        httpLoadingInterceptor,
      ])
    ),
    provideAnimations(),
    provideZoneChangeDetection(),
  ],
};
